module.exports = __webpack_public_path__ + "img/clere-target-dark.2ccdaa46.svg";